import React from 'react'

import { ComposedForm } from '@grandvision/forms'

import {
  DateOfBirth,
  Email,
  FirstName,
  LastName,
  PhoneNumber,
  PostalCode,
  Salutation,
} from './controls'

const AppointmentBookerForm: React.FC<{}> = () => (
  <>
    <ComposedForm.Part name="billingAddress">
      <Salutation />
      <FirstName />
      <LastName />
    </ComposedForm.Part>
    <ComposedForm.Part name="personalDetails">
      <PhoneNumber required={true} />
      <Email />
      <DateOfBirth />
    </ComposedForm.Part>
    <ComposedForm.Part name="billingAddress">
      <PostalCode required={true} />
    </ComposedForm.Part>
  </>
)

export default AppointmentBookerForm
